import * as React from "react";
import Modal from "react-modal";

import "../../newsroomFilters.css";
import SimpleButton from "../RenderComponents/SimpleButton";

interface IProps {
    allCategories: any[];
    allTags: string[];
    ariaLabel?: string;
    updateSelection: (selectedCategories: string[], selectedTags: string[]) => void;
    selectedCategories: string[];
    selectedTags: string[];
    showIcon?: boolean;
    text?: string;
    title?: string;
    type?: "a" | "button";
}

interface IState {
    currentTab: "categories" | "tags";
    currentlySelectedCategories: string[];
    currentlySelectedTags: string[];
    isPopupOpen: boolean;
    searchText: string;
}

export default class FilterPopup extends React.Component<IProps, IState> {
    public constructor(props) {
        super(props);
        this.state = {
            currentTab: "categories",
            currentlySelectedCategories: this.props.selectedCategories,
            currentlySelectedTags: this.props.selectedTags,
            isPopupOpen: false,
            searchText: "",
        };
    }

    public render() {
        return (
            <>
                <this.filterButton />
                <this.filtersCount />
                <this.popupFrame />
            </>
        );
    }

    private filterButton = () => {
        return (
            <SimpleButton
                className="CMS_button CMS_bAction"
                type={this.props.type || "button"}
                title={this.props.title || "Filters"}
                ariaLabel={this.props.ariaLabel || "Filters"}
                href={""}
                onClick={(e) => {
                    this.setState({
                        currentTab: "categories",
                        currentlySelectedCategories: this.props.selectedCategories.slice(),
                        currentlySelectedTags: this.props.selectedTags.slice(),
                        isPopupOpen: true,
                        searchText: "",
                    });
                    e.preventDefault();
                }}
            >
                {(this.props.showIcon || true) ? <em className="fa fa-filter" aria-hidden="true"></em> : null} {this.props.text || "Filter"}
            </SimpleButton>
        );
    }

    private filtersCount = () => {
        const totalSelectedFilters = this.props.selectedCategories.length + this.props.selectedTags.length;
        if (totalSelectedFilters === 0) {
            return null;
        }

        return (
            <div className="nr-filters-count">
                <span aria-label={totalSelectedFilters + " filters currently selected"}>
                    {totalSelectedFilters}
                </span>
            </div>
        );
    }

    private popupFrame = () => {
        return (
            <Modal
                ariaHideApp={false}
                className={"ReactModal__Content ReactModal__Content--after-open ReactModal__Content nr-filters-modal"}
                isOpen={this.state.isPopupOpen}
                overlayClassName={"ReactModal__Overlay ReactModal__Overlay--after-open ReactModal__Overlay CMS_PF_dialog CMS_PF_react CMS_react_ScrollingDialog"}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                onRequestClose={() => this.setState({ isPopupOpen: false })}
            >
                <div className="nr-filters">
                    <a
                        href=""
                        className="close-btn fa fa-times"
                        title="Close Filters"
                        aria-label="Close filters"
                        onClick={(e) => {
                            this.setState({ isPopupOpen: false });
                            e.preventDefault();
                        }}
                    >
                        <span className="offScreen">
                            Close Filters
                        </span>
                    </a>

                    <this.popupContents />
                </div>
            </Modal>
        );
    }

    private popupContents = () => {
        return (
            <div className="filters-container">
                <this.tabstrip />
                <this.selectAllBar />
                <this.descriptionBar />
                <this.searchBar />
                <this.filtersList />
                <this.popupFooter />
            </div>
        );
    }

    private tabstrip = () => {
        return (
            <div className="filter-tabs">
                <ul>
                    <li>
                        <a
                            aria-label="By Category"
                            className={this.state.currentTab === "categories" ? "filter-tab active" : "filter-tab"}
                            href=""
                            id="byCategory"
                            onClick={(e) => {
                                this.setState({ currentTab: "categories" });
                                e.preventDefault();
                            }}
                            title="By Category"
                        >
                            By Category
                        </a>
                    </li>
                    <li>
                        <a
                            aria-label="By Tag"
                            className={this.state.currentTab === "tags" ? "filter-tab active" : "filter-tab"}
                            href=""
                            id="byTag"
                            onClick={(e) => {
                                this.setState({ currentTab: "tags" });
                                e.preventDefault();
                            }}
                            title="By Tag"
                        >
                            By Tag
                        </a>
                    </li>
                </ul>
            </div>
        );
    }

    private selectAllBar = () => {
        return (
            <div className={"nr-filters-select-all " + (this.state.currentTab === "categories" ? "all-categories" : "all-tags")}>
                <label htmlFor={this.state.currentTab === "categories" ? "nr-all-categories" : "nr-all-tags"}>
                    {this.state.currentTab === "categories" ? "All Categories" : "All Tags"}
                </label>
                <input
                    aria-label={this.state.currentTab === "categories" ? "All Categories" : "All Tags"}
                    checked={
                        this.state.currentTab === "categories"
                            ? this.state.currentlySelectedCategories.length === 0
                            : this.state.currentlySelectedTags.length === 0
                    }
                    name={this.state.currentTab === "categories" ? "nr-all-categories" : "nr-all-tags"}
                    onChange={(e) => {
                        if (this.state.currentTab === "categories" && this.state.currentlySelectedCategories.length > 0) {
                            this.setState({ currentlySelectedCategories: [] });
                        } else if (this.state.currentlySelectedTags.length > 0) {
                            this.setState({ currentlySelectedTags: [] });
                        }
                    }}
                    id={this.state.currentTab === "categories" ? "nr-all-categories" : "nr-all-tags"}
                    type="checkbox"
                />
            </div>
        );
    }

    private descriptionBar = () => {
        return (
            <div className="filter-description">
                <div>
                    Or, only show ...
                </div>
                <div className="small-text">
                    select as many options as you want.
                </div>
            </div>
        );
    }

    private searchBar = () => {
        return (
            <div className="nr-filter-search">
                <label
                    className="offScreen"
                    htmlFor="nr-searchfilters"
                >
                    Search
                </label>
                <input
                    id="nr-searchfilters"
                    name="nr-searchfilters"
                    onChange={(e) => {
                        this.setState({ searchText: e.currentTarget.value });
                    }}
                    placeholder="Search..."
                    type="text"
                    value={this.state.searchText}
                />
                <span
                    aria-hidden="true"
                    className="fa fa-search"
                >
                </span>
            </div>
        );
    }

    private filtersList = () => {
        let allItems: Array<{ id: string, name: string }>;
        let selectedIds: string[];
        if (this.state.currentTab === "categories") {
            allItems = this.props.allCategories.map((x) => ({ id: x.categoryId, name: x.categoryName }));
            selectedIds = this.state.currentlySelectedCategories;
        } else {
            allItems = this.props.allTags.map((x) => ({ id: x, name: x }));
            selectedIds = this.state.currentlySelectedTags;
        }

        allItems = allItems.filter((x) => x.name.toLowerCase().includes(this.state.searchText.toLowerCase()));
        if (allItems.length === 0) {
            return (
                <div className="nr-filters-list">
                    <span className="NR_filter_empty">
                        No {this.state.currentTab === "categories" ? "Categories" : "Tags"} available.
                    </span>
                </div>
            );
        }

        return (
            <div className="nr-filters-list">
                <ul>
                    {allItems.map((item, i) => (
                        <li key={item.id}>
                            <label htmlFor={"nr-filters-" + i}>
                                {item.name}
                            </label>
                            <input
                                id={"nr-filters-" + i}
                                checked={selectedIds.includes(item.id)}
                                name={item.name} aria-label={item.name}
                                onChange={(e) => {
                                    const changingSelectedIds = this.state.currentTab === "categories"
                                        ? this.state.currentlySelectedCategories
                                        : this.state.currentlySelectedTags;

                                    const ti = changingSelectedIds.indexOf(item.id);
                                    if (ti >= 0) {
                                        changingSelectedIds.splice(ti, 1);
                                    } else {
                                        changingSelectedIds.push(item.id);
                                    }

                                    if (this.state.currentTab === "categories") {
                                        this.setState({ currentlySelectedCategories: changingSelectedIds });
                                    } else {
                                        this.setState({ currentlySelectedTags: changingSelectedIds });
                                    }
                                }}
                                type="checkbox"
                            />
                        </li>
                    ))}
                </ul>
            </div>
        );
    }

    private popupFooter = () => {
        return (
            <div className="nr-filter-footer">
                <button
                    aria-label="Clear Filters"
                    className="filter-footer-btn clear-filter"
                    onClick={() => {
                        this.setState({ searchText: "" });
                        if (this.state.currentTab === "categories") {
                            this.setState({ currentlySelectedCategories: [] });
                        } else {
                            this.setState({ currentlySelectedTags: [] });
                        }
                    }}
                    type="button"
                >
                    Clear
                </button>
                <button
                    aria-label="Apply Filters"
                    className="filter-footer-btn apply-filter"
                    onClick={() => {
                        this.props.updateSelection(this.state.currentlySelectedCategories, this.state.currentlySelectedTags);
                        this.setState({ isPopupOpen: false });
                    }}
                    type="button"
                >
                    Apply
                </button>
            </div>
        );
    }
}
